import CarouselAbstr, { CarouselOptions } from '../CarouselAbstr';
import Slide from '../Slide';
import Debouncer from '../../lib/Debouncer';

export default class featureCarousel extends CarouselAbstr {
	constructor(options: CarouselOptions) {
		super(options);

		this.init();
	}

	protected init(): void {
		const slidesColl = this.carouselEl.getElementsByClassName('featureCarousel__slide');
		for (let i = 0; i < slidesColl.length; i++) {
			const element = slidesColl[i];
			const isActive = i === 0;
			this.slides.push(new Slide({ element, isActive }));
		}

		const resetSlideHeight = () => {
			this.slides.forEach((slide: any) => {
				slide.element.style.height = 'auto';
			});
		}

		const setFrameHeight = () => {
			let tallestSlideHeight = 0;

			console.log('Slides: ', this.slides);

			this.slides.forEach((slide) => {
				const slideHeight = slide.element.clientHeight;

				if (slideHeight > tallestSlideHeight) {
					tallestSlideHeight = slideHeight;
				}
			});

			// Set all slides to be the height of the tallest one, so that each slide's text is vertically centered properly, and the images are all the same height (may only be noticeable on short screens)
			this.slides.forEach((slide: any) => {
				slide.element.style.height = `${tallestSlideHeight}px`;
			});

			// Set the frame to be the height of the tallest slide
			const carouselFrame = this.carouselEl.getElementsByClassName('featureCarousel__frame')[0] as HTMLObjectElement;
			carouselFrame.style.height = `${tallestSlideHeight}px`;
		}

		setFrameHeight();
		const resizeDebouncer = new Debouncer(() => {
			resetSlideHeight();
			setFrameHeight();
		});
		window.addEventListener('resize', resizeDebouncer.run, false);

		// if (this.slides.length === 1)
		// 	return;

		this.slides.forEach((slide, index) => {
			slide.element.appendChild(this.buildIndicators(index));
		});

		this.initAutoAdvance();
	}
}
